const SELECTORS = {
  form: "#aggregation-summary-form",
  axisSelect: "[data-company-reference-axis-select]",
  wrapper: "[data-company-reference-wrapper]",
  companyReferenceSelect: "[data-company-reference-select]",
  dropdown: ".ui.dropdown",
  applyButton: "#aggregation-summary-apply",
  loader: ".loader"
}

const query = (selector, root = document) => root.querySelector(selector)
const queryAll = (selector, root = document) => Array.from(root.querySelectorAll(selector))

const selectedOption = (select) => select?.selectedOptions?.[0] || null

export class CompanyReferenceTypeFieldsController {
  constructor(form) {
    this.form = form
    this.axisSelects = queryAll(SELECTORS.axisSelect, form)
    this.companyReferenceWrappers = queryAll(SELECTORS.wrapper, form)
    this.companyReferenceSelects = queryAll(SELECTORS.companyReferenceSelect, form)
    this.applyButton = query(SELECTORS.applyButton, form) || query(SELECTORS.applyButton)
  }

  connect() {
    this.bindSelectEvents()
    this.bindSubmitHandler()
    this.validate()
  }

  isCompanyAxis(select) {
    return selectedOption(select)?.dataset.target === "company"
  }

  companyReferenceValue(axisIndex) {
    const select = query(`[data-company-reference-select=\"${axisIndex}\"]`, this.form)
    return select?.value || "site_company"
  }

  toggleCompanyReferenceWrappers() {
    this.companyReferenceWrappers.forEach((wrapper) => {
      const axisIndex = wrapper.dataset.companyReferenceWrapper
      const axisSelect = query(`[data-company-reference-axis-select=\"${axisIndex}\"]`, this.form)

      wrapper.hidden = !this.isCompanyAxis(axisSelect)
    })
  }

  validate() {
    const chosen = []
    let duplicated = false

    this.toggleCompanyReferenceWrappers()

    this.axisSelects.forEach((select) => {
      const value = select.value
      if (!value || value === "none") return

      let signature = value
      if (this.isCompanyAxis(select)) {
        signature = `${value}:${this.companyReferenceValue(select.dataset.companyReferenceAxisSelect)}`
      }

      if (chosen.includes(signature)) duplicated = true
      chosen.push(signature)
    })

    this.axisSelects.forEach((select) => {
      select.classList.toggle("error", duplicated)
    })
    this.companyReferenceSelects.forEach((select) => {
      select.classList.toggle("error", duplicated)
    })
    if (this.applyButton) this.applyButton.disabled = duplicated
  }

  scheduleValidation() {
    window.requestAnimationFrame(() => this.validate())
    window.setTimeout(() => this.validate(), 0)
  }

  bindSelectEvents() {
    this.axisSelects.forEach((select) => {
      select.addEventListener("change", () => this.scheduleValidation())
      select.addEventListener("input", () => this.scheduleValidation())
    })

    this.companyReferenceSelects.forEach((select) => {
      select.addEventListener("change", () => this.scheduleValidation())
      select.addEventListener("input", () => this.scheduleValidation())
    })

    this.form.addEventListener("click", (event) => {
      if (event.target.closest(SELECTORS.dropdown)) {
        this.scheduleValidation()
      }
    })
  }

  bindSubmitHandler() {
    this.form.addEventListener("submit", () => {
      const loader = query(SELECTORS.loader)
      if (loader) loader.style.display = ""
    })
  }
}

export const initializeCompanyReferenceTypeFields = () => {
  const form = query(SELECTORS.form)
  if (!form || form.dataset.companyReferenceInitialized === "true") return

  form.dataset.companyReferenceInitialized = "true"
  new CompanyReferenceTypeFieldsController(form).connect()
}

document.addEventListener("DOMContentLoaded", initializeCompanyReferenceTypeFields)
document.addEventListener("turbolinks:load", initializeCompanyReferenceTypeFields)
document.addEventListener("turbo:load", initializeCompanyReferenceTypeFields)
